import { useEffect, useState } from "react";
import { Label, makeStyles, Persona } from "@fluentui/react-components";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IWorkspaceSummaryByOwnerReportSummaryProps } from "./workspace-summary-by-owner-report-summary.props";
import PercentageBar from "components/common/percentage-bar/percentage-bar";
import { getSizeLabel } from "lib/utils";

const layoutStyles = makeStyles({
    mainWrapper: {
        display: "flex",
        flexDirection: "row",
        gap: "2em"
    },
    column: {
        display: "flex",
        flexDirection: "column"
    },
    section: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "1em"
    }
});

export default function WorkspaceSummaryByOwnerReportSummary(props: IWorkspaceSummaryByOwnerReportSummaryProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    const [quotaLabel, setQuotaLabel] = useState<string>("");

    useEffect(() => {
        if (props.report?.details) {
            const used = getSizeLabel(props.report.details.totalStorageUsedKB, "KB");
            const quota = getSizeLabel(props.report.details.storageQuotaMB, "MB");
            setQuotaLabel(`(${t("ppaQuotaUsedValue", { used: used, quota: quota })})`);
        }
    }, [props.report?.details]);

    return (
        <div className={styles.mainWrapper}>
            {props.report?.details && (
                <>
                    <div className={styles.column}>
                        <div className={styles.section}>
                            <Label>{t("ppaWorkspaceRoleTypeOwner")}</Label>
                            <Persona
                                name={props.report.details.owner?.displayName}
                                secondaryText={props.report.details.owner?.upn}
                                size="small"
                            />
                        </div>
                    </div>

                    <div className={styles.column}>
                        <div className={styles.section}>
                            <Label>{t("ppaWorkspaceCount")}</Label>
                            <span>{props.report.details.workspaceCount}</span>
                        </div>
                        <div className={styles.section}>
                            <Label>{t("ppaInactiveCount")}</Label>
                            <span>{props.report.details.inactiveCount}</span>
                        </div>
                        <div className={styles.section}>
                            <Label>{t("ppaOrphanedCount")}</Label>
                            <span>{props.report.details.orphanedCount}</span>
                        </div>
                    </div>

                    <div className={styles.column}>
                        <div className={styles.section}>
                            <Label>{t("ppaPercentageOfQuota")}</Label>
                            <PercentageBar
                                value={props.report.details.percentageOfQuota}
                                valueDecimalPlaces={2}
                                showLabel={true}
                                additionalLabel={quotaLabel}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
